export function checkContrast(color, element) {
  // convert color from hex to rgb
  var r = parseInt(color.substr(1, 2), 16);
  var g = parseInt(color.substr(3, 2), 16);
  var b = parseInt(color.substr(5, 2), 16);
  // calculate contrast
  var contrast = (r * 299 + g * 587 + b * 114) / 1000;

  if (element && element.classList.contains("headline")) {
    const profileLinks = element.querySelectorAll("a");
    if (contrast > 128 && contrast < 150) {
      profileLinks.forEach((link) => {
        link.style.setProperty("color", "#000");
      });
    }
    if (contrast < 128) {
      profileLinks.forEach((link) => {
        link.style.setProperty("color", "#fff");
      });
    }
  }

  return contrast >= 128;
}

const projectCard = document.querySelectorAll(".project-card-figure");

if (projectCard) {
  projectCard.forEach(function (el) {
    var keyColor = getComputedStyle(el).getPropertyValue("--keyColor");
    var contrast = checkContrast(keyColor);

    if (contrast) {
      var element = el;
      element.style.setProperty("--textColor", "#000000");
    }
  });
}
